export default "<div class=\"checkbox--container\">\r\n  <mat-checkbox [(ngModel)]=\"value\">{{ label }}</mat-checkbox>\r\n</div>\r\n";